import { isInvalidPurchaseOrderNumber, isInvalidQuantity } from "src/validation/stringValidation";
import { FormValidator } from "../formValidator";
import { ValidationError, ValidationErrors } from "src/errors";
import { AmendTransitPurchaseOrderFormDataKey, TransitProductAmendmentInputField } from "src/types";

class AmendTransitPurchaseOrderFormValidator extends FormValidator {
  private static validatePurchaseOrderNumber(value: unknown): ValidationError<"purchaseOrderId"> | undefined {
    return isInvalidPurchaseOrderNumber(value)
      ? new ValidationError("Enter a valid purchase order number (e.g., 'PO-2055')", "purchaseOrderId")
      : undefined;
  }

  private static validateProductAmendments(value: unknown): ValidationError<"productAmendments"> | undefined {
    if (!Array.isArray(value) || !value.length) {
      return;
    }

    for (const arrayValue of value) {
      const { id, amendedReceivedQty } = arrayValue as TransitProductAmendmentInputField;

      if (isInvalidQuantity(amendedReceivedQty, 0)) {
        return new ValidationError(`Invalid received quantity (${id})`, "productAmendments");
      }
    }

    return;
  }

  public static validateTransitPurchaseOrderFormData(
    formData: Partial<Record<AmendTransitPurchaseOrderFormDataKey, unknown>>
  ): ValidationErrors<AmendTransitPurchaseOrderFormDataKey> {
    const validationErrors = new ValidationErrors<AmendTransitPurchaseOrderFormDataKey>();

    if ("purchaseOrderId" in formData) {
      const error = this.validatePurchaseOrderNumber(formData.purchaseOrderId);
      if (error) {
        validationErrors.push(error);
      }
    }

    if ("productAmendments" in formData) {
      const error = this.validateProductAmendments(formData.productAmendments);
      if (error) {
        validationErrors.push(error);
      }
    }

    return validationErrors;
  }
}

export { AmendTransitPurchaseOrderFormValidator };
